/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller('registrationCtrl', ['$scope', '$window', 'DebugHelper', '$filter', '$timeout', 'translateEn', 'UserManager', 'V3OAuthResource', function($scope, $window, DebugHelper, $filter, $timeout, translateEn, UserManager, V3OAuthResource) {
  DebugHelper.register("registrationCtrl", $scope);

  _.assignIn($scope, {
    stateUI: {
      currentAction: null
    },
    messageIndex: 0,
    UserManager,
    signInRoute: Packs.iKnowRoutes.v3_signin_path(),

    loadGoogleAuthentication() {
      return $scope.gAuth = gapi.load('auth2', () => $scope.auth2 = gapi.auth2.init({ client_id: "614534984451-u6an57t5thfuoh6ksqeskga9t0ee9dr7.apps.googleusercontent.com", scope: "email"}));
    },

    googleSignIn() {
      return $scope.auth2.grantOfflineAccess().then($scope.onGoogleSignIn);
    },

    onGoogleSignIn(authResult) {
      const params = { provider: 'google', code: authResult.code };
      return V3OAuthResource.authenticate(params
      , success => $window.location.href = Packs.iKnowRoutes.v3_dashboard_path()
      , error => $window.location.href = Packs.iKnowRoutes.v3_signin_path({error: "OauthError"}));
    },

    initialize() {
      return $scope.loadGoogleAuthentication();
    },


    loadQuotes() {
      angular.element(".registration-quote").removeClass("animated").addClass("animated");
      $scope.stateUI.currentQuote = $filter('translate')("js.registrations.quotes." + $scope.messageIndex + ".quote");
      $scope.stateUI.currentName = $filter('translate')("js.registrations.quotes." + $scope.messageIndex + ".name");
      $scope.messageIndex = ($scope.messageIndex + 1) % translateEn.default.en.js.registrations.quotes.length;
      return $timeout(() => $scope.loadQuotes()
      , 7000);
    },

    setCurrentAction(context) {
      return $scope.stateUI.currentAction =
        $scope.stateUI.userSignedIn ?
          "signout"
        :
          context || "signin";
    }
  }
  );

  $scope.initialize();
  $scope.loadQuotes();

  $scope.$on("registration:UserStatusChanged", function($event, user) {
    if (user.id) { $scope.stateUI.userSignedIn = true; }
    return $scope.setCurrentAction("signin");
  });

  return $scope.$on('$routeChangeSuccess', ($event, current, previous) => UserManager.loadUser().then(function(user) {
    if (user.id) { $scope.stateUI.userSignedIn = true; }
    return $scope.setCurrentAction(current.locals.$toggleAction);
  }));
}


]);
